import { render, staticRenderFns } from "./TestCard.vue?vue&type=template&id=7d36b0bd&scoped=true"
import script from "./TestCard.vue?vue&type=script&lang=ts"
export * from "./TestCard.vue?vue&type=script&lang=ts"
import style0 from "./TestCard.vue?vue&type=style&index=0&id=7d36b0bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d36b0bd",
  null
  
)

export default component.exports